import * as actionTypes from "./feedBackTypes";

const INTIAL_STATE = {
    isLoadingFeedBack: false,
    feedBackData: [],
};

const FeedBackReducer = (state = INTIAL_STATE, action) => {
    const { payload } = action;
    switch (action.type) {
        case actionTypes.IS_LOADING_FEEDBACK:
            return {
                ...state,
                isLoadingFeedBack: true
            };
        case actionTypes.FEEDBACK_SUCCESS:
            return {
                ...state,
                feedBackData: payload,
                isLoadingFeedBack: false
            };

        case actionTypes.FEEDBACK_FAILED:
            return {
                ...state,
                isLoadingFeedBack: false
            };

        default:
            return state;
    }
};

export default FeedBackReducer;
